import styled from 'styled-components';

const LandingHeaderStyle = styled.div`
	--heroImagePaddingTop: var(--sp163x);
	--titleMaxWidth: var(--sp137x);
	--titlePadding: var(--sp39x) var(--sp8x) var(--sp2x) var(--sp8x);
	--landingHeaderTop: var(--sp5x);
	--landingHeaderLeft: var(--sp5x);

	position: relative;
	overflow: hidden;

	.landing-header-logo {
		position: absolute;
		top: var(--landingHeaderTop);
		left: var(--landingHeaderLeft);
		z-index: 2;
	}

	.hero-image {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		padding-top: var(--heroImagePaddingTop);
	}

	.title {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		position: relative;
		height: var(--heroImagePaddingTop);
		max-width: var(--titleMaxWidth);
		padding: var(--titlePadding);
		z-index: 1;

		&.full-version {
			max-width: 100%;
		}
	}

	.layer {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 50%;
		background: var(--bgLayer);
		z-index: 1;
	}

	.layer-2 {
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 50%;
		background: var(--bgLayer);
		z-index: 1;
		transform: rotate(180deg);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--heroImagePaddingTop: var(--sp121x);
		--titleMaxWidth: var(--sp108x);
		--titlePadding: var(--sp25x) var(--sp6x) var(--sp2x) var(--sp6x);
		--landingHeaderTop: var(--sp4x);
		--landingHeaderLeft: var(--sp7x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--heroImagePaddingTop: var(--sp108x);
		--titleMaxWidth: var(--sp85x);
		--titlePadding: var(--sp20x) var(--sp4x) var(--sp2x) var(--sp4x);
		--landingHeaderTop: var(--sp3x);
		--landingHeaderLeft: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--heroImagePaddingTop: var(--sp94x);
		--titleMaxWidth: var(--sp85x);
		--titlePadding: var(--sp18x) var(--sp4x) var(--sp2x) var(--sp4x);
		--landingHeaderTop: var(--sp3x);
		--landingHeaderLeft: var(--sp5x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--heroImagePaddingTop: var(--sp95x);
		--titleMaxWidth: var(--sp72x);
		--titlePadding: var(--sp21x) var(--sp4x) var(--sp2x) var(--sp4x);
		--landingHeaderTop: var(--sp2x);
		--landingHeaderLeft: var(--sp4x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--heroImagePaddingTop: var(--sp95x);
		--titleMaxWidth: var(--sp53x);
		--titlePadding: var(--sp23x) var(--sp4x) var(--sp2x) var(--sp4x);
		--landingHeaderTop: var(--sp2x);
		--landingHeaderLeft: var(--sp4x);
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--heroImagePaddingTop: var(--sp128x);
		--titleMaxWidth: var(--sp53x);
		--titlePadding: var(--sp39x) var(--sp4x) var(--sp2x) var(--sp4x);
		--landingHeaderTop: var(--sp2x);
		--landingHeaderLeft: var(--sp4x);
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--heroImagePaddingTop: var(--sp112x);
		--titleMaxWidth: var(--sp32x);
		--titlePadding: var(--sp37x) var(--sp3x) var(--sp2x) var(--sp3x);
		--landingHeaderTop: var(--sp2x);
		--landingHeaderLeft: var(--sp3x);

		.title {
			&.full-version {
				font-size: var(--sp4x);
			}
		}

		@media (max-width: 360px) {
			.title {
				&.full-version {
					font-size: var(--sp3-5x);
				}
			}
		}
	}
`;

export default LandingHeaderStyle;
